import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'unorm';
import 'url-search-params-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from "react-redux";
import {BrowserRouter as Router} from "react-router-dom";
import configureStore from "./store";
import ReactGA from "react-ga";
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

ReactGA.initialize("UA-xxxxxx-x");
ReactGA.pageview(window.location.pathname + window.location.search);

const store = configureStore(/* provide initial state if any */)

let rendered = false;
while (!rendered) {
  const rootElement = document.getElementById('fow-root');
  if (rootElement){
    rendered = true;
    //console.info('fow-root element is present. Rendering...');
    ReactDOM.render(
      <Provider store={store}>
        <Router>
          <App />
        </Router>
      </Provider>
    , document.getElementById('fow-root'));
  } else {
    console.warn('fow-root element is NOT present. Retrying...');
  }
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
